var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17393_43054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6044 4.28508C17.6071 5.66579 14.2513 6.79154 10.1092 6.79952C5.96709 6.80749 2.60708 5.69467 2.60442 4.31396M17.6044 4.28508C17.6017 2.90438 14.2417 1.79155 10.0996 1.79953C5.95747 1.8075 2.60176 2.93325 2.60442 4.31396M17.6044 4.28508L17.6269 15.9517C17.6295 17.3351 14.2983 18.4581 10.1317 18.4662C5.96502 18.4742 2.62954 17.3639 2.62688 15.9806L2.60442 4.31396M17.6156 10.1184C17.6183 11.5017 14.2871 12.6248 10.1205 12.6328C5.95379 12.6409 2.61831 11.5306 2.61565 10.1473",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17393_43054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0966797 0.1521) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase01);
export default __webpack_public_path__ + "static/media/database-01.9705847c8e3ec605d1b0e66c61ffd269.svg";
export { ForwardRef as ReactComponent };